
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternStbd as ObiLightLanternStbdElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-stbd.js';
 
 
 

 
 export const ObiLightLanternStbd = createComponent({
   react: React,
   tagName: 'obi-light-lantern-stbd',
   elementClass: ObiLightLanternStbdElement,
   events: {
     
   }
  });
 
 